export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          关于麻花影院
        </h2>
        <p className="text-foreground-500 text-center text-sm md:text-base mb-10">
          了解麻花影院的定位与初心
        </p>
        <div className="rounded-2xl bg-background-100 border border-background-200/70 p-8 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 items-center">
            <div>
              <h3 className="text-xl md:text-2xl font-heading text-foreground-950 mb-4">
                聚合好片，让观影更简单
              </h3>
              <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>
                  麻花影院成立于2024年，是一家专注于聚合最新高清电影资源的在线观影平台。
                  我们致力于打破观影门槛，让每一位影迷都能轻松找到并观看自己喜欢的电影。
                </p>
                <p>
                  平台覆盖动作片、科幻片、喜剧电影、悬疑惊悚、爱情片、动画电影等十余个分类，
                  片库总量超过5000部，且每周保持50部以上的更新速度。
                </p>
                <p>
                  无需注册、无需付费、高清流畅——这是麻花影院始终坚持的服务理念。
                  我们相信，好电影应该被更多人看到。
                </p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="rounded-xl bg-primary-50 p-5 text-center">
                <div className="text-3xl font-bold text-primary-500 mb-1">5000+</div>
                <div className="text-xs text-foreground-500">高清影片</div>
              </div>
              <div className="rounded-xl bg-accent-50 p-5 text-center">
                <div className="text-3xl font-bold text-accent-500 mb-1">50+</div>
                <div className="text-xs text-foreground-500">每周更新</div>
              </div>
              <div className="rounded-xl bg-secondary-50 p-5 text-center">
                <div className="text-3xl font-bold text-secondary-500 mb-1">10+</div>
                <div className="text-xs text-foreground-500">分类覆盖</div>
              </div>
              <div className="rounded-xl bg-primary-50 p-5 text-center">
                <div className="text-3xl font-bold text-primary-500 mb-1">0</div>
                <div className="text-xs text-foreground-500">无需付费</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}